import { render, staticRenderFns } from "./SpecifiedCommercialTransactionsAct.vue?vue&type=template&id=04e04031"
import script from "./SpecifiedCommercialTransactionsAct.vue?vue&type=script&lang=ts"
export * from "./SpecifiedCommercialTransactionsAct.vue?vue&type=script&lang=ts"
import style0 from "./SpecifiedCommercialTransactionsAct.vue?vue&type=style&index=0&id=04e04031&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e04031')) {
      api.createRecord('04e04031', component.options)
    } else {
      api.reload('04e04031', component.options)
    }
    module.hot.accept("./SpecifiedCommercialTransactionsAct.vue?vue&type=template&id=04e04031", function () {
      api.rerender('04e04031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/SpecifiedCommercialTransactionsAct.vue"
export default component.exports